import { Anchor } from '@/components/ui/Anchor'
import { cn } from '@/lib/utils'

export interface LegalNavSection {
  number: string
  title: string
}

export interface LegalSideNavProps {
  sections: LegalNavSection[]
  className?: string
}

/**
 * Sticky table of contents for long-form legal documents. `Anchor` handles the
 * smooth scroll to each section — no scroll-tracking JS needed.
 */
export function LegalSideNav({ sections, className }: LegalSideNavProps) {
  return (
    <nav className={cn('sticky top-[86px] self-start max-[900px]:hidden', className)} aria-label="Sections">
      <ul className="m-0 flex list-none flex-col border-l border-white p-0">
        {sections.map((section) => (
          <li key={section.number}>
            <Anchor
              href={`#section-${section.number}`}
              className="text-ink-500 hover:border-brand hover:text-ink -ml-px grid grid-cols-[3ch_1fr] gap-x-1 border-l-2 border-transparent py-2 pl-4 font-mono text-xs leading-[1.4] no-underline transition-[color,border-color] duration-150"
            >
              <span className="text-right">{section.number}.</span>
              <span>{section.title}</span>
            </Anchor>
          </li>
        ))}
      </ul>
    </nav>
  )
}
